import { render, staticRenderFns } from "./data_card2.vue?vue&type=template&id=0a710356&scoped=true"
import script from "./data_card2.vue?vue&type=script&lang=js"
export * from "./data_card2.vue?vue&type=script&lang=js"
import style0 from "./data_card2.vue?vue&type=style&index=0&id=0a710356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a710356",
  null
  
)

export default component.exports